import React, { useState } from "react";
import { HiMenu, HiX } from "react-icons/hi";
import Logo from '../Asset/Logo-Hotel-Hub.png';
const Header = ({ scrollTo }) => {
  const [open, setOpen] = useState(false);

  const links = ["home", "services", "about", "contact"];

  return (
    <header className="bg-gray-950 text-white fixed w-full z-50 shadow-md">
      <div className="max-w-7xl mx-auto flex justify-between items-center p-4">
        <div className="flex items-center space-x-2">
          <img
            src={Logo}
            alt="Logo"
            className="h-8 w-8 rounded-full object-cover"
          />
          <span className="text-blue-500 font-bold text-xl">Hotel-Hub</span>
        </div>
        {/* Desktop */}
        <nav className="hidden md:flex space-x-6">
          {links.map((link) => (
            <button key={link} onClick={() => scrollTo(link)} className="hover:text-blue-400">
              {link.charAt(0).toUpperCase() + link.slice(1)}
            </button>
          ))}
        </nav>
        {/* Mobile */}
        <button className="md:hidden text-2xl" onClick={() => setOpen(!open)}>
          {open ? <HiX /> : <HiMenu />}
        </button>
      </div>
      {/* Mobile Menu */}
      {open && (
        <div className="md:hidden bg-gray-950 flex flex-col space-y-2 p-4">
          {links.map((link) => (
            <button
              key={link}
              onClick={() => { scrollTo(link); setOpen(false); }}
              className="text-white hover:text-blue-400 text-left"
            >
              {link.charAt(0).toUpperCase() + link.slice(1)}
            </button>
          ))}
        </div>
      )}
    </header>
  );
};

export default Header;
